import { Routes } from '@angular/router';
import { HomeComponent } from '@modules/home/home.component';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

export enum Route {
  WEBSHOPS = 'webshops',
  GALLERIES = 'galleries',
  CUSTOMERS = 'customers',
  COMPANIES = 'companies',
  PAGES = 'pages',
  HOME = ''
}

export const routes: Routes = [
  {
    path: Route.WEBSHOPS,
    loadChildren: () => import('../webshops/webshop.module').then(m => m.WebshopModule),
    canActivate: [AutoLoginPartialRoutesGuard]
  },
  {
    path: Route.GALLERIES,
    loadChildren: () => import('../galleries/gallery.module').then(m => m.GalleryModule),
    canActivate: [AutoLoginPartialRoutesGuard]
  }, {
    path: Route.CUSTOMERS,
    loadChildren: () => import('../customers/customer.module').then(m => m.CustomerModule),
    canActivate: [AutoLoginPartialRoutesGuard]
  }, {
    path: Route.COMPANIES,
    loadChildren: () => import('../companies/companies.module').then(m => m.CompaniesModule),
    canActivate: [AutoLoginPartialRoutesGuard]
  }, {
    path: 'home',
    component: HomeComponent,
    pathMatch: 'full',
  }, {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];
